import { ROUTE } from 'routers/data';

const commonTitle = 'Datos Personales';
const commonText =
  'Esta información es <b>obligatoria</b> y será verificada para crear su alta en la plataforma y por lo tanto deve ser <b>verdadera.</b>';

export const stepsData: {
  [x: string]: { title: string; text: string; next?: string; done: boolean };
} = {
  0: {
    title: commonTitle,
    text: commonText,
    next: ROUTE.complateProfileStep2,
    done: false,
  },
  1: {
    title: commonTitle,
    text: commonText,
    next: ROUTE.complateProfileStep3,
    done: false,
  },
  2: {
    title: 'Valida tu dirección',
    text: '',
    next: ROUTE.complateProfileStep4,
    done: false,
  },
  3: {
    title: 'Documentación para Presentar',
    text: 'Por favor cargue los siguientes archivos opcionales para que la empresa evalúe su alta. Considere que mientras más archivos cargue mas rápida será su alta y sus clientes podrán ver más datos personales suyos en su perfil para mayor confianza. <b>El DNI Y EL TÍTULO DE CURSO/ESTUDIO FINALIZADO es obligatorio</b>.',
    done: true,
  },
};
